/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IEngagementsTotalItem } from 'pages/Dashboard/Dashboard.models';
// eslint-disable-next-line no-unused-vars
import { TPeriod } from 'shared/CustomRangePicker/CustomRangePicker.models';
import { getEngagementsOrdersTOTotal } from './api.service';

export interface IState {
  data: IEngagementsTotalItem[];
  isLoading: boolean;
  error: object | null;
}

const initialState: IState = {
  data: [],
  error: null,
  isLoading: false,
};

export const getEngagementsOrdersTOTotalAction = createAsyncThunk(
  'getEngagementsOrdersTOTotalAction',
  async (
    { controller, params }: {params: TPeriod, controller: AbortController},
    { rejectWithValue },
  ) => {
    const { signal } = controller;

    try {
      const { data } = await getEngagementsOrdersTOTotal(signal, params);
      return data;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

const EngagementsOrdersTOTotalSlice = createSlice({
  name: 'getEngagementsOrdersTOTotalSlice',
  initialState,
  reducers: {
    clear: () => initialState,
  },
  extraReducers(builder) {
    builder
      .addCase(getEngagementsOrdersTOTotalAction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getEngagementsOrdersTOTotalAction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(getEngagementsOrdersTOTotalAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
        state.data = [];
      });
  },
});

export const { clear: clearEngagementsOrdersTOTotalAction } = EngagementsOrdersTOTotalSlice.actions;

export const getEngagementsOrdersTOTotalReducer = EngagementsOrdersTOTotalSlice.reducer;
